import React from 'react';
import PropTypes from 'prop-types';

import { SvgIcon as MUISvgIcon } from '@mui/material';

export const SvgIcon = props => <MUISvgIcon {...props} />;

SvgIcon.propTypes = {
  classes: PropTypes.object,
  fontSize: PropTypes.oneOf(['default', 'inherit', 'large', 'small']),
  htmlColor: PropTypes.string,
  style: PropTypes.object,
  titleAccess: PropTypes.string,
  viewBox: PropTypes.string
};

export default SvgIcon;
